/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryResponse,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentagePathParams,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage401,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage500,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage.ts";

function getGetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageUrl(
  discountTypeId: GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentagePathParams["discountTypeId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/editors/discount-types/${discountTypeId}/percentage` as const,
  };
  return res;
}

/**
 * @description Migrado do legado RegistryAsync/GetDiscountPercentage. **(Requer Authorization para autenticação)**
 * @summary Percentual do tipo de desconto (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/editors/discount-types/:discountTypeId/percentage}
 */
export async function getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage(
  discountTypeId: GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentagePathParams["discountTypeId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage401
      | GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageUrl(
      discountTypeId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
